import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig"

const API_URL = `${API_BASE_URL}/api/CarePlan`;



export const getCarePlansByPatient = async (cipId) => {
    try {
        // Construyes la URL con el parámetro de ruta
        const url = `${API_URL}/${cipId}`;
        
        // Llamada HTTP GET
        const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        
        return response.data;
    } catch (error) {
        console.error("Error fetching careplan info:", error);
        throw error;
    }
};

